import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import styled from 'styled-components'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import Image from 'components/Common/Image/Image'
import Sheet from 'components/utils/Sheet'
import clsx from 'clsx'

const Root = styled(Sheet)`
  background-color: ${props => props.theme.palette.neutral.default.eight};

  &.background-color-white {
    background-color: ${props => props.theme.palette.neutral.default.eight};
  }

  &.background-color-grey {
    background-color: ${props => props.theme.palette.neutral.default.seven};
  }
`

const LogoCarousel = styled(CardCarousel)`
  margin-top: ${rem(24)};
`

const LogoWrapper = styled.div`
  padding: ${rem(8)} ${rem(16)};
  display: flex;
  align-items: center;
  justify-content: center;

  &.with-outline {
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
  }
`

const PAGE_SIZE = 8

function ContentfulLogosCarousel(props: App.ComponentLogoCarousel) {
  return <Root padding="40 0" paletteType={props.backgroundColor === 'dark' ? 'inverse' : 'default'} className={clsx(`background-color-${props.backgroundColor}`)}>
    <LayoutContainer>
      <Heading variant="heading3" dangerouslySetInnerHTML={{ __html: props.title }} />
      <LogoCarousel pageSize={PAGE_SIZE} gap={12}>
        {props.images.map((image) => (
          <LogoWrapper key={image.title} className={clsx({ 'with-outline': props.withOutline })}>
            <Image width={80} image={image} alt={image.title} />
          </LogoWrapper>
        ))}
      </LogoCarousel>
    </LayoutContainer>
  </Root>
}

export default ContentfulLogosCarousel
